import { render } from "./TranslationSegment.vue?vue&type=template&id=6daa04a5&scoped=true&ts=true"
import script from "./TranslationSegment.vue?vue&type=script&lang=ts"
export * from "./TranslationSegment.vue?vue&type=script&lang=ts"

import "./TranslationSegment.vue?vue&type=style&index=0&id=6daa04a5&lang=css"
import "./TranslationSegment.vue?vue&type=style&index=1&id=6daa04a5&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6daa04a5"]])

export default __exports__